import _loadView from 'rlink-router/actions/_loadView';
import hideTooltip from 'rlink-tooltips/actions/hideTooltip';

/**
 * Open up a new named flyout view
 *
 * @param {BuildContext} options.buildContext The current build context. Required if view is also given.
 * @param  {string} options.view    A view function name. (mutually exclusive with `content`).
 * @param  {object} options.params  Params object for view function. (mutually exclusive with `content`).
 * @param  {PropType.node} options.content React renderable content. (mutually exclusive with `view` and `params`).
 * @param  {string} options.name  FLyouts must be identified by a name so they can later closedm etc.
 * @return {Thunk}
 */
export default function openFlyout ({buildContext, view, params, content = undefined, name}) {
  return async dispatch => {
    if (content === undefined) {
      content = await dispatch(_loadView(buildContext, view, params));
    }
    dispatch(hideTooltip());
    dispatch({
      type: 'MOUNT_FLYOUT',
      payload: {name, content},
    });
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/openFlyout.js